// Confetti burst for the first-word moment. Keeps it tiny and tasteful.
import confetti from "canvas-confetti";

export function fireFirstWordConfetti() {
  const duration = 1400;
  const end = Date.now() + duration;

  const colors = ["#FFB627", "#FF6B47", "#6FAE6D", "#5AA9E6", "#F38BA8"];

  // Two-sided cannons converging to the center
  (function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 60,
      origin: { x: 0, y: 0.7 },
      colors,
      scalar: 1.1,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 60,
      origin: { x: 1, y: 0.7 },
      colors,
      scalar: 1.1,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();

  // One big center burst on top
  setTimeout(() => {
    confetti({
      particleCount: 90,
      spread: 100,
      origin: { y: 0.5 },
      colors,
      startVelocity: 38,
      scalar: 1.3,
    });
  }, 80);
}
